// /theme/core/modal.js

export class SFTModal {
    static instance;
    scrollPosition = 0;

    constructor() {
        if (SFTModal.instance) return SFTModal.instance;

        this.dialog = document.createElement('dialog');
        this.dialog.classList.add('sft-modal');
        document.body.appendChild(this.dialog);

        this.dialog.addEventListener('click', (e) => {
            if (e.target === this.dialog) this.close(); // click outside to close
        });

        // Close handler for ESC or dialog.close()
        this.dialog.addEventListener('close', () => this.unlockScroll());

        SFTModal.instance = this;
    }

    open(htmlContent = '') {
        // Clear old content
        this.dialog.innerHTML = '';

        const container = document.createElement('div');
        container.classList.add('sft-modal-inner');
        container.innerHTML = htmlContent;

        // Add ✖️ close button
        const closeButton = document.createElement('button');
        closeButton.classList.add('sft-modal-close');
        closeButton.setAttribute('type', 'button');
        closeButton.textContent = '✖️';
        closeButton.addEventListener('click', () => this.close());

        container.prepend(closeButton);
        this.dialog.appendChild(container);

        // Lock scroll
        this.lockScroll();

        if (!this.dialog.open) this.dialog.showModal();
    }

    close() {
        this.dialog.close();
        this.dialog.innerHTML = '';
        // unlockScroll is now called by the 'close' event
    }

    lockScroll() {
        this.scrollPosition = window.scrollY;
        document.body.classList.add('modal-open');
        const page = document.querySelector('#page');
        if (page) {
            page.style.position = 'fixed';
            page.style.top = `-${this.scrollPosition}px`;
            page.style.width = '100%';
        }
    }

    unlockScroll() {
        document.body.classList.remove('modal-open');
        const page = document.querySelector('#page');
        if (page) {
            page.style.position = '';
            page.style.top = '';
            page.style.width = '';
        }
        window.scrollTo(0, this.scrollPosition);
    }
}
